<template>
  <div class="appointment-wrapper">
    <!-- 信息展示区域 -->
    <div class="info-section">
      <!-- 车辆信息 -->
      <div class="info-card">
        <div class="card-header">
          <van-icon name="logistics" size="18" />
          <span>车辆信息</span>
        </div>
        <div
          class="card-content"
          v-if="JSON.stringify(chetouInfo) !== '{}' && JSON.stringify(cheguaInfo) !== '{}'"
        >
          <div class="info-item">
            <div class="item-label">车头号：</div>
            <div class="item-value">{{ chetouInfo.chetouhao }}</div>
          </div>
          <div class="info-item">
            <div class="item-label">车头行驶证有效期：</div>
            <div class="item-value">{{ chetouInfo.xingshizhengyxq }}</div>
          </div>
          <div class="info-item">
            <div class="item-label">车挂号：</div>
            <div class="item-value">{{ cheguaInfo.cheguahao }}</div>
          </div>
          <div class="info-item">
            <div class="item-label">车挂行驶证有效期：</div>
            <div class="item-value">{{ cheguaInfo.xingshizhengyxq }}</div>
          </div>
          <div class="info-item">
            <div class="item-label">车挂核定载质量：</div>
            <div class="item-value">
              {{ cheguaInfo.xingshizhenghdzzl ? cheguaInfo.xingshizhenghdzzl : 0 }}吨(T)
            </div>
          </div>
        </div>
        <div class="card-content error-content" v-else>
          <van-icon name="warning-o" color="#ff4d4f" />
          <span>请完成车辆绑定以及备案</span>
        </div>
      </div>

      <!-- 驾驶员信息 -->
      <div class="info-card">
        <div class="card-header">
          <van-icon name="manager-o" size="18" />
          <span>驾驶员信息</span>
        </div>
        <div class="card-content" v-if="!yhjsybaztslot">
          <div class="info-item">
            <div class="item-label">驾驶员：</div>
            <div class="item-value">{{ driverInfo.name }}</div>
          </div>
          <div class="info-item">
            <div class="item-label">身份证：</div>
            <div class="item-value">{{ driverInfo.shenfenzheng }}</div>
          </div>
        </div>
        <div class="card-content error-content" v-else>
          <van-icon name="warning-o" color="#ff4d4f" />
          <span>请完成驾驶员信息添加以及备案</span>
        </div>
      </div>

      <!-- 押送员信息 -->
      <div class="info-card">
        <div class="card-header">
          <van-icon name="friends-o" size="18" />
          <span>押送员信息</span>
        </div>
        <div class="card-content" v-if="!yhyyybaztslot">
          <div class="info-item">
            <div class="item-label">押送员：</div>
            <div class="item-value">{{ escortInfo.name }}</div>
          </div>
          <div class="info-item">
            <div class="item-label">身份证：</div>
            <div class="item-value">{{ escortInfo.shenfenzheng }}</div>
          </div>
        </div>
        <div class="card-content error-content" v-else>
          <van-icon name="warning-o" color="#ff4d4f" />
          <span>请完成押送员信息添加以及备案</span>
        </div>
      </div>
    </div>

    <!-- 预约表单区域 -->
    <div class="form-section">
      <div class="form-card">
        <div class="card-header">
          <van-icon name="clock-o" size="18" />
          <span>预约信息</span>
        </div>
        <div class="card-content">
          <van-form @submit="onSubmit">
            <van-field
              class="form-field"
              :value="yyrq"
              clickable
              readonly
              label="预约日期"
              placeholder="点击选择时间"
              @click="showTimePicker2 = true"
              :rules="[{ validator: validatorYyrq, message: '请选择预约日期' }]"
            >
              <template #left-icon>
                <van-icon name="calendar-o" size="18" class="field-icon" />
              </template>
              <template #right-icon>
                <van-icon name="arrow" class="arrow-icon" />
              </template>
            </van-field>

            <van-field
              v-model="inputYyNumber"
              class="form-field"
              type="number"
              name="预约数量（吨）"
              label="预约数量"
              required
              :rules="[{ validator: validatorInputYyNumber, message: '请输入预约数量' }]"
              placeholder="请输入预约数量（吨）"
            >
              <template #left-icon>
                <van-icon name="balance-o" size="18" class="field-icon" />
              </template>
              <template #right-icon>
                <span class="unit-text">吨</span>
              </template>
            </van-field>
            <!-- 卸货单号 -->
            <van-field
              v-model="xhdh"
              class="form-field"
              name="xhdh"
              label="卸货单号"
              placeholder="请输入卸货单号"
            >
              <template #left-icon>
                <van-icon name="notes-o" size="18" class="field-icon" />
              </template>
            </van-field>
            <!-- 铅封号 -->
            <van-field
              v-model="qfh"
              class="form-field"
              name="qfh"
              label="铅封号"
              placeholder="请输入铅封号"
            >
              <template #left-icon>
                <van-icon name="label-o" size="18" class="field-icon" />
              </template>
            </van-field>
            <div class="submit-btn-wrapper">
              <van-button round block type="primary" native-type="submit">提交预约</van-button>
            </div>
          </van-form>
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirmDate"
        @cancel="showTimePicker = false"
        :formatter="formatter"
      />
    </van-popup>

    <van-popup v-model="showTimePicker2" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showTimePicker2 = false"
        @confirm="onConfirm"
      />
    </van-popup>

    <Tabbar></Tabbar>
  </div>
</template>

<script>
import api from '@/fetch/api';
import Tabbar from '../Public/tabbarTpl.vue';
import { Toast, Dialog } from 'vant';
export default {
  components: {
    Tabbar,
  },
  created() {
    console.log('到了。。。。');
    document.title = '预约信息确认';
    var openid = this.$store.state.wx_info.openid;
    this.openid = openid;
    //根绝时间判定maxDate
    this.getMaxDate();

    //判断绑定信息
    this.getBindVehicleState();
    //获取绑定车辆信息
    this.getVehicleInfo();
    //获取驾驶员/押送员信息
    this.getDriverByOpenid();
    this.getEscortByOpenid();
    this.getkyyyrq();
    this.getSysInfo();
  },
  data() {
    return {
      openid: '',
      inputYyNumber: 0,
      yhcgbaztslot: false,
      yhctbaztslot: false,
      yhjsybaztslot: false,
      yhyyybaztslot: false,
      // 备案审核状态原始值（1=未提交 2=审核中 3=审核通过）
      yhcgbazt: '',
      yhctbazt: '',
      yhjsybazt: '',
      yhyyybazt: '',
      chetouInfo: {},
      cheguaInfo: {},
      driverInfo: [],
      escortInfo: [],
      columns: [],
      showTimePicker: false,
      yyrq: '',
      cctwly: 0, //cctwly 新版本
      minDate: new Date(),
      maxDate: new Date(2099, 11, 31),
      currentDate: new Date(),
      showTimePicker2: false,
      showPicker: false,
      showField: false,
      // 卸货单号
      xhdh: '',
      // 铅封号
      qfh: '',
    };
  },
  methods: {
    getMaxDate() {
      const now = new Date();
      // 获取当前的小时数
      const currentHour = now.getHours();
      const tomorrow = new Date(now);
      // 判断当前时间是否超过晚上6点
      if (currentHour >= 18) {
        tomorrow.setDate(now.getDate() + 1);
        this.maxDate = tomorrow;
      }
      // 如果在晚上6点之前，则maxDate为今天的日期，但时间设为晚上6点之前的一毫秒
      else {
        this.maxDate = tomorrow;
      }
    },
    validatorInputYyNumber(val) {
      if (!val || parseFloat(val) > 49) {
        Toast.fail('请填写正确的预约数量');
        return false;
      }
    },
    validatorYyrq(val) {
      if (!val) {
        Toast.fail('请选择预约日期');
        return false;
      }
    },
    onConfirmDate() {
      var confirmDate = `${this.value1}-${this.value2}-${this.value3}`;
      this.yyrq = confirmDate;
      this.onCancelDate();
    },
    onCancelDate() {
      this.showTimePicker = false;
    },
    showTime() {
      this.showTimePicker = true;
    },
    formatter(type, value) {
      if (type === 'year') {
        this.value1 = value; // 可以拿到当前点击的数值
        return `${value}年`;
      } else if (type === 'month') {
        this.value2 = value;
        return `${value}月`;
      }
      this.value3 = value;
      return `${value}日`;
    },

    //输入预约数量
    onSubmit() {
      // 车头/车挂/驾驶员/押送员 备案审核状态校验：必须全部为 3（审核通过）才能提交预约
      var checkList = [
        { zt: this.yhctbazt, name: '车头' },
        { zt: this.yhcgbazt, name: '车挂' },
        { zt: this.yhjsybazt, name: '驾驶员' },
        { zt: this.yhyyybazt, name: '押送员' },
      ];
      for (var i = 0; i < checkList.length; i++) {
        var item = checkList[i];
        if (item.zt != '3') {
          var msg =
            item.zt == '2'
              ? item.name + '正在审核中，请等待审核通过后再预约'
              : item.name + '未提交审核，请先完成提交审核';
          Dialog({
            message: msg,
          });
          return false;
        }
      }

      if (this.inputYyNumber <= 0) {
        Dialog({
          message: '请填写您要预约的数量',
        });
        return false;
      }

      var type = this.$route.params.type;
      var yyrq = this.yyrq;

      if (yyrq == '') {
        Dialog({
          message: '请选择您要预约的日期',
        });
        return false;
      }

      if (type == 'tihuo') {
        this.$router.push({
          name: 'appointmentnew',
          params: {
            number: this.inputYyNumber,
            yyrq: yyrq,
          },
        });
      } else if (type == 'xiehuo') {
        this.$router.push({
          name: 'appointmentxhnew',
          params: {
            number: this.inputYyNumber,
            yyrq: yyrq,
            xhdh: this.xhdh,
            qfh: this.qfh,
          },
        });
      } else {
        this.$router.push({
          name: 'index',
        });
      }
    },
    //判断绑定信息
    getBindVehicleState() {
      var openid = this.$store.state.wx_info.openid;
      var that = this;
      api
        .getBindVehicleState(openid)
        .then(function (resData) {
          var res = JSON.parse(resData);
          if (res.respCode == 0) {
            that.$data.vehicleState = res.data.yhzt;
            var yhcgbazt = res.data.yhcgbazt;
            var yhctbazt = res.data.yhctbazt;
            var yhjsybazt = res.data.yhjsybazt;
            var yhyyybazt = res.data.yhyyybazt;
            // 保存原始审核状态，提交预约时校验（必须全部为 3 审核通过）
            that.yhcgbazt = yhcgbazt;
            that.yhctbazt = yhctbazt;
            that.yhjsybazt = yhjsybazt;
            that.yhyyybazt = yhyyybazt;
            let yhcgbaztslot = 0,
              yhctbaztslot = 0,
              yhjsybaztslot = 0,
              yhyyybaztslot = 0;
            if (yhcgbazt == '0' || yhcgbazt == '1') yhcgbaztslot++;
            if (yhctbazt == '0' || yhctbazt == '1') yhctbaztslot++;
            if (yhjsybazt == '0' || yhjsybazt == '1') yhjsybaztslot++;
            if (yhyyybazt == '0' || yhyyybazt == '1') yhyyybaztslot++;
            that.yhcgbaztslot = yhcgbaztslot ? true : false;
            that.yhctbaztslot = yhctbaztslot ? true : false;
            that.yhjsybaztslot = yhjsybaztslot ? true : false;
            that.yhyyybaztslot = yhyyybaztslot ? true : false;
            that.yhctbaztslot = false; //正式环境需要删除
          }
        })
        .catch(function () {
          //
        });
    },
    //获取车辆xinxi
    getVehicleInfo() {
      var that = this;
      var openid = that.openid;
      if (!that.yhctbaztslot && !that.yhcgbaztslot) {
        //车头信息
        api
          .getChetouBeianDetail(openid)
          .then(function (resData) {
            var res = JSON.parse(resData);
            if (res.respCode == 0) {
              var detail = res.data;
              if (detail.vehicleUsage == '2') that.chetouInfo = detail;
            }
          })
          .catch(function () {
            Toast.fail('连接失败，请刷新页面');
          });

        //获取车挂id
        api
          .getVehicleInfo(openid)
          .then(function (resData) {
            var res = JSON.parse(resData);
            if (res.respCode == 0) {
              var cheguaid = res.data.cheguaid;
              //车挂信息
              api
                .getCheguaBeianDetail(cheguaid)
                .then(function (resDataNew) {
                  var resNew = JSON.parse(resDataNew);
                  if (res.respCode == 0) {
                    var detail = resNew.data;
                    if (detail.vehicleUsage == '2') that.cheguaInfo = detail;
                    //that.cheguaInfo = resNew.data;
                  }
                })
                .catch(function () {
                  Toast.fail('连接失败，请刷新页面');
                });
            }
          })
          .catch(function () {
            Toast.fail('连接失败，请刷新页面');
          });
      }
    },
    //获取驾驶员信息
    getDriverByOpenid() {
      var that = this;
      var openid = that.openid;
      api
        .getDriverByOpenid(openid)
        .then(function (res) {
          var resData = JSON.parse(res);
          if (resData.respCode == '0') {
            var detail = resData.data;
            that.driverInfo = detail[0];
          }
        })
        .catch(function () {
          Toast.fail('连接失败，请刷新页面');
        });
    },
    //获取押送员信息
    getEscortByOpenid() {
      var that = this;
      var openid = that.openid;
      api
        .getEscortByOpenid(openid)
        .then(function (res) {
          var resData = JSON.parse(res);
          if (resData.respCode == '0') {
            var detail = resData.data;
            that.escortInfo = detail[0];
          }
        })
        .catch(function (err) {
          console.log(err);
          Toast.fail('连接失败，请刷新页面');
        });
    },
    //获取系统信息
    getSysInfo() {
      var openid = this.$store.state.wx_info.openid;
      var that = this;
      //获取系统信息
      api
        .getSysInfo(openid)
        .then(function (resData) {
          var res = JSON.parse(resData);
          if (res.respCode == 0) {
            var cctwly = res.data.cctwly;
            that.cctwly = cctwly;
          }
        })
        .catch(function () {
          //Toast.fail('连接失败，请刷新页面');
        });
    },
    getkyyyrq() {
      var that = this;

      //获取系统信息
      var postData = {};

      api
        .getkyyyrq(postData)
        .then(function (resData) {
          var res = JSON.parse(resData);
          if (res.respCode == 0) {
            that.$data.showField = true;
            that.$data.showPicker = true;

            var dataList = res.data;
            var columns = [];
            for (var i = 0; i < dataList.length; i++) {
              columns.push({
                id: i,
                text: dataList[i]['pdrq'],
              });
            }
            that.columns = columns;
          } else if (res.respCode < 0) {
            Dialog.alert({
              message: res.message,
            }).then(() => {});
          } else {
            Dialog.alert({
              message: '连接异常',
            }).then(() => {});
          }
        })
        .catch(function () {
          //Toast.fail('连接失败，请刷新页面');
        });
    },
    onConfirm(value) {
      this.showTimePicker2 = false;
      var text = value.text;
      this.yyrq = text;
    },
  },
};
</script>

<style lang="scss" scoped>
.appointment-wrapper {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding: 12px;
  padding-bottom: 60px;
}

.info-section,
.form-section {
  margin-bottom: 12px;
}

.info-card,
.form-card {
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 12px;
  overflow: hidden;

  .card-header {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #f5f6f7;

    .van-icon {
      color: #4080ff;
      margin-right: 8px;
    }

    span {
      font-size: 16px;
      font-weight: 500;
      color: #323233;
    }
  }

  .card-content {
    padding: 12px 16px;

    &.error-content {
      display: flex;
      align-items: center;
      color: #ff4d4f;

      .van-icon {
        margin-right: 8px;
        font-size: 18px;
      }
    }
  }
}

.info-item {
  display: flex;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }

  .item-label {
    color: #969799;
    font-size: 14px;
    min-width: 100px;
  }

  .item-value {
    flex: 1;
    color: #323233;
    font-size: 14px;
    font-weight: 500;
  }
}

.form-field {
  margin-bottom: 12px;

  .field-icon {
    margin-right: 6px;
    color: #4080ff;
  }

  .arrow-icon {
    color: #c8c9cc;
  }

  .unit-text {
    color: #969799;
    font-size: 14px;
  }
}

.submit-btn-wrapper {
  margin-top: 24px;

  .van-button {
    height: 44px;
    font-size: 16px;
    background-color: #4080ff;
    border: none;
  }
}
</style>
